import { Button as LibButton } from "@mui/material";

import styled, { css } from "styled-components";

import { isSmallDesktop } from "@/hooks/layout";

type TButton = {
  $isOutlined: boolean;
  $isFullWidth: boolean;
  $isBigButton: boolean;
  $isIconButtonLike: boolean;
  $dimmed?: boolean;
  width: number;
};

export const Button = styled(LibButton)<TButton>`
  && {
    font-weight: 600;
    font-size: ${({ $isIconButtonLike }) => ($isIconButtonLike ? "0.8125rem" : "0.9375rem")};
    font-family: "Raleway", sans-serif;
    line-height: 135%;
    border-radius: 8px;
    box-sizing: border-box;
    width: fit-content;
    padding-inline: 16px;
    text-transform: none;

    ${({ $isIconButtonLike }) =>
      $isIconButtonLike &&
      css`
        padding-right: 13px;
      `}

    height: ${({ $isBigButton }) => ($isBigButton ? "48px" : "40px")};

    ${({ width }) =>
      width &&
      css`
        width: ${width}px;
      `}

    ${({ $isFullWidth }) =>
      $isFullWidth &&
      css`
        width: 100%;
      `}

    ${({ $isOutlined, $isIconButtonLike }) =>
      $isOutlined
        ? css`
            color: #ebc28e;
            display: inline-block;
            position: relative;
            z-index: 0;
            border-radius: ${$isIconButtonLike ? "4px" : "8px"};
            background: transparent;
            border: 1px solid rgba(235, 194, 142, 0.4);
            transition: all 0.2s ease;

            path {
              fill: #ebc28e;
              transition: fill 0.2s ease;
            }

            &:hover {
              background: rgba(235, 194, 142, 0.1);
              border-color: #ebc28e;
            }

            &:active {
              background: #ebc28e;
              color: #3c2d23;

              path {
                fill: #3c2d23;
              }
            }

            ${isSmallDesktop} {
              &:hover {
                background: rgba(235, 194, 142, 0.1);
                border-color: #ebc28e;
              }
            }
          `
        : css`
            background: linear-gradient(135deg, #ffd29b 0%, #ffebb5 100%);
            color: #3c2d23;
            border: none;
            transition: all 0.3s ease;
            box-shadow: 0 0 20px rgba(186, 144, 92, 0.3);

            &:hover {
              box-shadow: 0 0 32px rgba(186, 144, 92, 0.5);
              transform: translateY(-1px);
            }

            &:active {
              transform: translateY(0);
              box-shadow: 0 0 16px rgba(186, 144, 92, 0.3);
            }
          `}

    &.Mui-disabled {
      background: rgba(81, 58, 40, 0.6);
      color: rgba(251, 244, 236, 0.3);
      border: 1px solid rgba(235, 194, 142, 0.1);
      box-shadow: none;
    }

    /* Looks like the disabled state but stays clickable — for "required field
       not done yet" buttons that should trigger a shake on click rather than
       blocking it (mirrors the cart's $dimmed PrimaryBtn). Placed after the
       gold default so it wins at equal specificity. */
    ${({ $dimmed }) =>
      $dimmed &&
      css`
        background: rgba(81, 58, 40, 0.6);
        color: rgba(251, 244, 236, 0.3);
        border: 1px solid rgba(235, 194, 142, 0.1);
        box-shadow: none;

        &:hover {
          background: rgba(81, 58, 40, 0.6);
          box-shadow: none;
        }
      `}

    ${({ $isIconButtonLike }) =>
      $isIconButtonLike &&
      css`
        padding-block: 0;
        height: 32px;
      `}

    ${isSmallDesktop} {
      ${({ $isBigButton }) =>
        $isBigButton &&
        css`
          padding-inline: 32px;
        `}
    }
  }
`;
